import {
  createTheme as createMuiTheme,
  responsiveFontSizes,
} from '@mui/material/styles';

export const createThemeFactory = ({
  createBaseOptions,
  createDarkOptions,
  createLightOptions,
  createTypography,
}) => (config) => {
  let theme = createMuiTheme(
    createBaseOptions({ direction: config.direction }),
    createTypography({ isDyslexic: config.isDyslexic }),
    config.paletteMode === 'dark'
      ? createDarkOptions({ colorPreset: config.colorPreset, contrast: config.contrast, branding: config.branding })
      : createLightOptions({ colorPreset: config.colorPreset, contrast: config.contrast, branding: config.branding })
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
